import React, { useState, useEffect } from "react";
import { CreditCard, ReceiptOutlined } from "@material-ui/icons";
import "./paymentmethods.css";

export const PaymentMethods = ({
  defaultCard,
  cards = [],
  availableMethods = ["card-list", "new-card", "boleto", "pix"],
  recommendedMethod = "card-list",
  onMethodChange,
}) => {
  const [selectedMethod, setSelectedMethod] = useState(
    availableMethods.includes(recommendedMethod)
      ? recommendedMethod
      : availableMethods[0]
  );

  const [showCardList, setShowCardList] = useState(false);
  const [selectedCard, setSelectedCard] = useState(
    defaultCard  || null 
  );
useEffect(() => {
  const cardToUse =
    defaultCard ||
    cards.find(card => card.in_use) ||
    cards[0] ||
    null;

  if (cardToUse) {
    setSelectedCard(cardToUse);
    setSelectedMethod("card-list");
  }
}, [defaultCard, cards]);
  useEffect(() => {
    onMethodChange({method: selectedMethod, card: selectedMethod === "card-list" ? selectedCard : null});
  }, [selectedMethod, selectedCard, onMethodChange]);
  
  const handleMethodChange = (method) => {
    if (method !== "card-list") {
      setShowCardList(false);
    }
    setSelectedMethod(method);
  };

  const handleCardSelection = (card) => {
    setSelectedCard(card);
  };

  const toggleCardList = () => {
    setShowCardList(!showCardList);
  };

  return (
    <div className="payment-methods-container">
      <h2 className="payment-title">Forma de pagamento</h2>

      {availableMethods.includes("card-list") && (
        <div
          className={`payment-method-item ${selectedMethod === "card-list" ? "selected" : ""}`}
          onClick={() => handleMethodChange("card-list")}
        >
          <div className="payment-method-info">
            <div className="payment-method-icon-container">
              <CreditCard />
            </div>
            <div className="payment-method-details">
              <span className="payment-method-name">Cartão de Crédito</span>
              {selectedCard && (
                <span className="payment-method-description">
                  {selectedCard.brand} - Final {selectedCard.last_digits}{" "}
                  {selectedCard.in_use ? "(Padrão)" : ""}
                </span>
              )}
            </div>
          </div>
          <div className="payment-method-selector">
            {recommendedMethod === "card-list" && (
              <span className="recommended-badge">Recomendado</span>
            )}
            <input
              type="checkbox"
              checked={selectedMethod === "card-list"}
              onChange={() => {}} // Controlado pelo onClick do container
              className="checkbox"
            />
          </div>
        </div>
      )}

      {selectedMethod === "card-list" && (
        <button className="toggle-cards-button" onClick={toggleCardList} style={{marginBottom: showCardList ? "16px" : "24px"}}>
          <span>
            Selecionar outro cartão
          </span>
          <span className={`arrow-icon ${showCardList ? "up" : "down"}`}></span>
        </button>
      )}

      {showCardList && (
        <div className="cards-list">
          {cards.map((card) => (
            <div
              key={card.id}
              className={`payment-method-item card-option ${selectedCard?.id === card.id ? "card-selected" : ""}`}
              onClick={() => handleCardSelection(card)}
            >
              <div className="payment-method-info">
                <span className="payment-method-description">
                  {card.brand} - Final {card.last_digits}{" "}
                  {card.in_use ? "(Padrão)" : ""}
                </span>
              </div>
              <div className="payment-method-selector">
                <input
                  type="checkbox"
                  checked={selectedCard?.id === card.id}
                  onChange={() => {}}
                  className="checkbox"
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {availableMethods.includes("new-card") && (
        <div
          className={`payment-method-item ${selectedMethod === "new-card" ? "selected" : ""}`}
          onClick={() => handleMethodChange("new-card")}
        >
          <div className="payment-method-info">
            <div className="payment-method-icon-container">
              <CreditCard />
            </div>
            <span className="payment-method-name">Adicionar novo cartão</span>
          </div>
          <div className="payment-method-selector">
            {recommendedMethod === "new-card" && (
              <span className="recommended-badge">Recomendado</span>
            )}
            <input
              type="checkbox"
              checked={selectedMethod === "new-card"}
              onChange={() => {}} // Controlado pelo onClick do container
              className="checkbox"
            />
          </div>
        </div>
      )}

      {availableMethods.includes("boleto") && (
        <div
          className={`payment-method-item ${selectedMethod === "boleto" ? "selected" : ""}`}
          onClick={() => handleMethodChange("boleto")}
        >
          <div className="payment-method-info">
            <div className="payment-method-icon-container">
              <ReceiptOutlined />
            </div>
            <span className="payment-method-name">Boleto Bancário</span>
          </div>
          <div className="payment-method-selector">
            {recommendedMethod === "boleto" && (
              <span className="recommended-badge">Recomendado</span>
            )}
            <input
              type="checkbox"
              checked={selectedMethod === "boleto"}
              onChange={() => {}} // Controlado pelo onClick do container
              className="checkbox"
            />
          </div>
        </div>
      )}

      {availableMethods.includes("pix") && (
        <div
          className={`payment-method-item ${selectedMethod === "pix" ? "selected" : ""}`}
          onClick={() => handleMethodChange("pix")}
        >
          <div className="payment-method-info">
            <div className="payment-method-icon-container">
              PIX
            </div>
            <span className="payment-method-name">Pix</span>
          </div>
          <div className="payment-method-selector">
            {recommendedMethod === "pix" && (
              <span className="recommended-badge">Recomendado</span>
            )}
            <input
              type="checkbox"
              checked={selectedMethod === "pix"}
              onChange={() => {}} // Controlado pelo onClick do container
              className="checkbox"
            />
          </div>
        </div>
      )}
    </div>
  );
};